import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationConstant } from '@constant/navigation.constant';
import { ParentHelper } from '@helper/parent.helper';

@Component({
  selector: 'app-akulaku',
  templateUrl: './akulaku.component.html',
  styleUrls: ['./akulaku.component.css']
})
export class AkulakuComponent implements OnInit {

  img: string;
  count: number = 0;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    this.img = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/akulaku.png';
  }

  goHome(){
    ParentHelper.navigate(NavigationConstant.HOME_REDIRECT);
    if(this.count >= 1){
      window.location.href =  window.location.origin+NavigationConstant.HOME_BO;
    }
    this.count++;
  }


}
